import { jsx as u, jsxs as b } from "react/jsx-runtime";
import { c as C } from "react/compiler-runtime";
import { TextField as I, InputAdornment as T, Box as g } from "@mui/material";
import v from "@mui/icons-material/Search";
import { useState as B } from "react";
import { debounce as P } from "lodash";
import { u as j } from "../../../chunks/TableContext.js";
import { styles as x } from "./styles.js";
function k() {
  const e = C(12), {
    searchPlaceholder: f,
    onSearchChange: s,
    searchLeftComponent: r,
    disableTableSearch: o
  } = j(), c = f === void 0 ? "Search..." : f, [i, S] = B("");
  let n;
  e[0] !== s ? (n = P((p) => {
    s?.(p);
  }, 300), e[0] = s, e[1] = n) : n = e[1];
  const h = n;
  let a;
  e[2] !== h ? (a = (p) => {
    const d = p.target.value;
    S(d), h(d);
  }, e[2] = h, e[3] = a) : a = e[3];
  const m = a;
  if (o && !r)
    return null;
  let t;
  e[4] !== o || e[5] !== m || e[6] !== i || e[7] !== c ? (t = !o && /* @__PURE__ */ u(I, { placeholder: c, value: i, onChange: m, InputProps: {
    startAdornment: /* @__PURE__ */ u(T, { position: "start", children: /* @__PURE__ */ u(v, { sx: {
      fontSize: "16px"
    } }) })
  }, sx: x.tableSearchTextField }), e[4] = o, e[5] = m, e[6] = i, e[7] = c, e[8] = t) : t = e[8];
  let l;
  return e[9] !== r || e[10] !== t ? (l = /* @__PURE__ */ b(g, { sx: x.searchBarContainer, children: [
    r,
    t
  ] }), e[9] = r, e[10] = t, e[11] = l) : l = e[11], l;
}
export {
  k as TableSearchBar
};
